import React, { useState } from "react";
import "./styles.scss";

import Input from "../../../common/Input";
import Button from "../../../common/button";
import { InputLabel } from "@mui/material";
import { isEmailAddressValid } from "../../../utils";
import {
  postScoreList,
  postKalvioEmail,
} from "../../../store/homeAction/action";
import { useStateValue } from "../../../store";

const EmailSection = ({ email_id, view }) => {
  const [{}, dispatch] = useStateValue();
  const [email, setEmail] = useState({
    email_address: email_id ? email_id : sessionStorage.getItem("mail_id"),
    name: "",
  });
  const [isError, setIsError] = useState({
    email: "",
    name: "",
  });

  const handleValidation = () => {
    let errorHandle = false;
    if (!isEmailAddressValid(email?.email_address)) {
      setIsError((prev) => ({
        ...prev,
        email: "Please enter the valid e-mail address.",
      }));
      errorHandle = true;
    }
    if (!email?.name) {
      setIsError((prev) => ({
        ...prev,
        name: "Please enter the name.",
      }));
      errorHandle = true;
    }
    if (!errorHandle) {
      //api call
      let payload = {
        email: email?.email_address,
        name: email?.name,
        assesment_for: JSON.parse(sessionStorage.getItem("qtnValues"))
          ?.identify_person,
        assesment: [
          ...Object.entries(
            JSON.parse(sessionStorage.getItem("qtnValues"))?.question
          ).map(([__, answer]) => ({
            question_no: parseInt(answer?.id),
            answer: answer?.value,
          })),
        ],
      };
      setIsError((prev) => ({
        ...prev,
        email: "",
        name: "",
      }));
      dispatch({
        type: "SET_IS_LOADING",
        value: true,
      });
      postScoreList((res, error) => {
        dispatch({
          type: "SET_IS_LOADING",
          value: false,
        });

        if (res?.status) {
          JSON.stringify(
            sessionStorage.setItem("mail_id", email?.email_address)
          );
          dispatch({
            type: "SET_ALERT_MESSAGE",
            value: true,
            data: { severity: "success", message: res?.data },
          });
          setEmail((prev) => ({
            ...prev,
            email_address: "",
          }));
          dispatch({
            type: "SET_EMAIL_POPUP",
            value: false,
          });
        } else {
          dispatch({
            type: "SET_EMAIL_POPUP",
            value: false,
          });
          dispatch({
            type: "SET_ALERT_MESSAGE",
            value: true,
            data: { severity: "error", message: res?.data },
          });
        }
        if (error) {
          dispatch({
            type: "SET_ALERT_MESSAGE",
            value: true,
            data: {
              severity: "error",
              message: "Something went wrong, Please try again.",
            },
          });
        }
      }, payload ,view === "score_page" ? "score_page" :"");

      postKalvioEmail((res, error) => {}, {
        email: email?.email_address,
        name: email?.name,
      });
    }
  };
  return (
    <div className="email-section-container">
      <div className="input-container">
        <InputLabel>Name</InputLabel>
        <Input
          placeholder="your name"
          className="inputfield-box"
          value={email?.name}
          onChange={(event) => {
            setEmail((prev) => ({
              ...prev,
              name: event.target.value,
            }));
            setIsError((prev) => ({
              ...prev,
              name: "",
            }));
          }}
        />
        <p className="validation_error">{isError?.name}</p>
      </div>
      <div className="input-container">
        <InputLabel>Email address</InputLabel>
        <Input
          placeholder="example@gmail.com"
          className="inputfield-box"
          value={email?.email_address}
          onChange={(event) => {
            setEmail((prev) => ({
              ...prev,
              email_address: event.target.value,
            }));
            setIsError((prev) => ({
              ...prev,
              email: "",
            }));
          }}
        />
        <p className="validation_error">{isError?.email}</p>
      </div>
      <Button onClick={() => handleValidation()}>
        {view === "score_page"
          ? "Sign up for our newsletter"
          : "Send my detailed report"}
      </Button>
      <div className="notes-verify">
        <p style={{fontSize:"12px"}}>
          {view === "score_page"
            ? "*By providing your email you are agreeing to subscribe to our newsletter and receive promotional content"
            : ""}
        </p>
      </div>
    </div>
  );
};

export default EmailSection;
